import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ScrollToTop from './routers/ScrollToTop';
import reportWebVitals from './reportWebVitals';

const theme = createTheme({
  palette: {
    primary: {
      main: '#268c83',
    },
    secondary: {
      main: '#1398bf',
    },
  },
  typography: {
    fontFamily: 'Raleway, sans-serif',
    h1: {
      fontFamily: 'Gotham, sans-serif',
    },
    h2: {
      fontFamily: 'Gotham, sans-serif',
    },
    h3: {
      fontFamily: 'Gotham, sans-serif',
    },
    h4: {
      fontFamily: 'Gotham, sans-serif',
    },
    h5: {
      fontFamily: 'Gotham, sans-serif',
    },
    h6: {
      fontFamily: 'Gotham, sans-serif',
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ScrollToTop>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
